import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";

function LancerTraitements() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div style={{ textAlign: "center" }}>
        <h1>Lancer des traitements</h1>

        <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
          <button onClick={() => navigate("/carto-meteo")}>
            Carto météo
          </button>

          <button onClick={() => navigate("/spotify")}>
            Spotify
          </button>
        </div>
        
        <div style={{ marginTop: "40px" }}>
           <button onClick={() => navigate("/")} style={{ backgroundColor: "#666" }}>
             Retour Accueil
           </button>
        </div>
      </div>
    </Layout>
  );
}

export default LancerTraitements;